"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Example for this renderer:
 *   "renderAs": {
 *       "type": "Image",
 *       "class": "html",
 *       "settings": {
 *           "imageUrlPath": "fields.avatar_thumb"
 *       }
 *   }
 *
 * Example with specified height/width
 *   "renderAs": {
 *       "type": "Image",
 *       "class": "html",
 *       "settings": {
 *           "imageUrlPath": "fields.avatar_thumb",
 *           "height": "75px",
 *           "width": "75px"
 *       }
 *   }
 */
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var imageUrl = row[settings.imageUrlPath];
    if (!imageUrl) {
      return null;
    }
    var imgHeight = settings.height || '55px';
    var imgWidth = settings.width || '55px';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center ".concat(_style["default"].tableImage),
      style: {
        backgroundImage: "url(".concat(imageUrl, ")"),
        height: imgHeight,
        width: imgWidth
      },
      key: row
    });
  };
};